import { useEffect } from "react";
import InputFactory from "../../../../../components/InputFactory";
import { getAllYears } from "./utils";

function Filters({ year, onChange, onFilter }) {
  const _onChange = (value, field) => {
    onChange(value, field);
  };

  useEffect(() => {
    if (year != null && year !== "") {
      onFilter();
    }
  }, [year]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2">
          <div className="col-md-auto d-flex align-items-center">
            <label className="fw-medium">Year:</label>
          </div>
          <div className="col-md d-flex flex-column flex-md-row gap-2">
            <InputFactory
              type="Enum"
              options={getAllYears()}
              defaultValue={`${year}`}
              className="bg-white"
              placeholder="Select Year"
              field="year"
              onChange={_onChange}
              required
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Filters;
